<template>
  <div class="news-headlines-detail">
        <headerBlack-view></headerBlack-view>
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/news' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: `${breadcrumb.path}` }">{{breadcrumb.name}}</el-breadcrumb-item>
            <el-breadcrumb-item>项目详情</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <breadCrumb></breadCrumb> -->
        <div class="news-detail-wrapper main flex-between">
            <div class="news_detail_left">
                <div class="content-box">
                    <div class="title-box">
                        <h3 class="f18">{{article.title}}</h3>
                        <p class="source f12">
                            <span> 来源：{{article.source}}</span> 
                            <span> 作者：{{article.author}} </span>
                            <span> 责任编辑：{{article.editor}}</span> 
                            <!-- <span> 责任编辑：张璐 </span> -->
                        </p>
                        <p class="other-info f12 flex-layout">
                            <span>{{article.createTime.split(':').slice(0,2).join(':')}}</span>
                            <span class="eye">{{article.views || 0}}</span>
                        </p>
                    </div>
                    <div class="content" v-html="article.content"></div>
                    <div class="pagination flex-align-between">
                       <p class="pv wes" :class="[!prev.id? 'not-hover' : '']" @click="toPage(prev)">上一篇：{{prev.id ? prev.title :'无'}}</p>
                       <p class="next wes" :class="[!next.id? 'not-hover' : '']" @click="toPage(next)">下一篇：{{next.id ? next.title :'无'}}</p>
                    </div>
                   
                </div>
            </div>
            <div class="news_detail_right">
                <div class="subtitle flex-align-between">
                    <h2 class="text text-first f16 flex-align">最新推荐</h2>
                </div>
                <div class="timeline-list">
                    <el-timeline>
                      <el-timeline-item
                        v-for="(activity, index) in activities"
                        :key="index"
                        type="primary"
                        color="#BEE3FF"
                        size="large"
                        :timestamp="activity.detailCreateTime.split(':').slice(0,2).join(':')"
                        class="timeline-item">
                        <p class="f12" @click="toPage(activity)">{{activity.detailCreateTime.split(':').slice(0,2).join(':')}}</p>
                        <p class="f12" @click="toPage(activity)">{{activity.introduction}}</p>
                      </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
  </div>
</template>

<script>
export default {
    data() {
        return {
        crumbPath:'',
        crumbName:'',
        crumbTopicListId:1,
        article:{},
        prev:{},
        next:{},
        hasHover:false,
        proId:0,
        activities: [],
        clazzMap:{
            90:4,
            109:5,
            110:6,
        }
        }
    },
    computed:{
        breadcrumb() {
            let map = {
                90 : {
                    name:'首师智研',
                    path:'/yunqiao/wisdom'
                },
                109 : {
                    name:'1+X后勤管理与职业教育系统',
                    path:'/yunqiao/logistics'
                },
                110 : {
                    name:'内蒙古自治区三科统编教材中部四盟市教师专项培训',
                    path:'/yunqiao/innerMongolia'
                },
            }
            return map[this.proId] ? map[this.proId] : {name:'',path:''}
        }
    },
    methods:{
        async getArticle() {
            let params = {
                id:this.$route.params.id
            }
            let resData = await Api.News.GetNewsDetail(params);
            this.article = resData.data;
        },

        // 获取最新推荐
        async getRecommend() {
          let params = {
            clazz:this.clazzMap[Number(sessionStorage.getItem('projectID'))], //首师智妍
            isAsc:'desc',
            pageNum: 1,
            pageSize: 7,
          }
          let resData = await Api.Wisdom.getProjectList(params)
          console.log(resData);
          if(resData.rows);
          this.activities = resData.rows;
        },

        async getNearInfo () {
            let params = {
                id:this.$route.params.id
            }
            let resData = await Api.News.GetNear(params);
            this.prev = resData.data[0];
            this.next = resData.data[1];
        },
        toPage(item){
            if(!item.id) return
            Common.goPage(`/yunqiao/project/detail/${item.id}`,this)
            this.getArticle();
            this.getNearInfo();
        
        }
    },
    mounted(){
        this.proId = Number(sessionStorage.getItem('projectID'));
        this.getArticle();
        this.getRecommend();
        this.getNearInfo();
    },
}
</script>

<style lang="less">
    @import "./less/news_headlines_detail.less";
</style>